import React from 'react';
import Modal from '../../Modal/ReactBootstrapModal';
import config from '../../../../config';
import clubs from '../../../../constants/clubs';
import { getClubsEmail, displayNameForRole } from '../../../utils/clubs';

const getInactiveClubEmailDisplay = (clubTierType) => {
    const emailId = getClubsEmail(clubTierType);
    return (
        <a href={`mailto: ${emailId}`} data-testid="modal.club-inactive.email-link">{emailId}</a>
    );
};

export const ClubInactivePopup = (props) => {
    const {
        status,
        close,
        show,
        clubTierType,
    } = props;
    return (
        <Modal visible={show} onClickBackdrop={close} dialogClassName="modal-lg">
            <div className="modal-header">
                <div className="text-medium" data-testid="modal.club-inactive.title">Action Not Permitted</div>
                <div className="close-icon" onClick={close} data-testid="modal.club-inactive.close-btn">
                    <i className="utr utr-close" />
                </div>
            </div>
            <div className="modal-body">
                {(clubTierType?.isHighSchool && status === 'pending') ? (
                    <p className="mb24" data-testid="modal.club-inactive.description">
                        {`You're on your way to claiming your High School! Please email `}
                        <a href={`mailto:${clubs.highSchoolTeamEmail}`} data-testid="modal.club-inactive.email-link">{clubs.highSchoolTeamEmail}</a>{` with your picture ID and the name of the school you are trying to claim - we'll get right back with you!`}
                    </p>
                ) : (
                    <p className="mb24" data-testid="modal.club-inactive.description">
                        {`Your club account is ${status || 'inactive'}. Until this issue is resolved, you cannot create events, post scores, or add members. Contact `}
                        {getInactiveClubEmailDisplay(clubTierType)} for assistance.
                    </p>
                )}
                <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={close} data-testid="modal.club-inactive.ok-btn">OK</button>
            </div>
        </Modal>
    );
};

export const OrganizerLimitPopup = (props) => {
    const {
        type,
        close,
        show,
    } = props;
    return (
        <Modal visible={show} onClickBackdrop={close} dialogClassName="modal-lg">
            <div className="modal-header">
                <div className="text-medium" data-testid="modal.organizer-limit.title">Action Not Permitted</div>
                <div className="close-icon" onClick={close} data-testid="modal.organizer-limit.close-btn">
                    <i className="utr utr-close" />
                </div>
            </div>
            <div className="modal-body">
                <p className="mb24" data-testid="modal.organizer-limit.description">
                    {`You have reached your limit for ${type}. Please `}
                    <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`} data-testid="modal.organizer-limit.support-link">contact the Support team</a> with any questions.
                </p>
                <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={close} data-testid="modal.organizer-limit.ok-btn">OK</button>
            </div>
        </Modal>
    );
};

export const MemberLimitPopup = (props) => {
    const {
        memberRole,
        close,
        show,
    } = props;
    return (
        <Modal visible={show} onClickBackdrop={close} dialogClassName="modal-lg">
            <div className="modal-header">
                <div className="text-medium" data-testid="modal.member-limit.title">Cannot Add Member</div>
                <div className="close-icon" onClick={close} data-testid="modal.member-limit.close-btn">
                    <i className="utr utr-close" />
                </div>
            </div>
            <div className="modal-body">
                <p className="mb24" data-testid="modal.member-limit.description">
                    {`You have reached your member limit for ${displayNameForRole(memberRole)}s. If you need additional assistance, please contact `}
                    <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`} data-testid="modal.member-limit.support-link">Support</a>.
                </p>
                <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={close} data-testid="modal.member-limit.ok-btn">OK</button>
            </div>
        </Modal>
    );
};

export const AlreadyCreatedClubPopup = (props) => {
    const {
        close,
        show,
    } = props;
    return (
        <Modal visible={show} onClickBackdrop={close} dialogClassName="modal-lg">
            <div className="modal-header">
                <div className="text-medium" data-testid="modal.already-created-club.title">Action Not Permitted</div>
                <div className="close-icon" onClick={close} data-testid="modal.already-created-club.close-btn">
                    <i className="utr utr-close" />
                </div>
            </div>
            <div className="modal-body">
                <p className="mb24" data-testid="modal.already-created-club.description">
                    {`You have already created your players group`}
                </p>
                <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={close} data-testid="modal.already-created-club.ok-btn">OK</button>
            </div>
        </Modal>
    );
};

export const AddMemberSuccessPopup = (props) => {
    const {
        invitePlayers,
        showPlayerMessage,
        close,
        confirm,
        show,
    } = props;
    const playerMessage = invitePlayers ? 'Player has been successfully invited to your roster' : 'Player has been successfully added to your roster';
    return (
        <Modal visible={show} dialogClassName="modal-lg">
            <div className="modal-header">
                <div className="text-medium" data-testid="modal.add-member-success.title">Success!</div>
            </div>
            <div className="modal-body">
                <p className="mb24" data-testid="modal.add-member-success.description">
                    {`${showPlayerMessage ? playerMessage : 'This member has been successfully added to your club'} and will be notified.`}
                </p>
                <div className="row">
                    <div className="col-6">
                        <button type="button" className={`btn btn-xl btn-block btn-default`} onClick={close} data-testid="modal.add-member-success.exit-btn">Exit</button>
                    </div>
                    <div className="col-6">
                        <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={confirm} data-testid="modal.add-member-success.add-another-btn">Add Another</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export const MemberPowerLimitPopup = (props) => {
    const {
        maxPowerUsers,
        close,
        show,
    } = props;
    return (
        <Modal visible={show} onClickBackdrop={close} dialogClassName="modal-lg">
            <div className="modal-header">
                <div className="text-medium" data-testid="modal.member-power-limit.title">Cannot Add Member</div>
                <div className="close-icon" onClick={close} data-testid="modal.member-power-limit.close-btn">
                    <i className="utr utr-close" />
                </div>
            </div>
            <div className="modal-body">
                <p className="mb24" data-testid="modal.member-power-limit.description">
                    {`You have used your ${maxPowerUsers} Power subscriptions for your club members. Please contact your account administrator or our`}
                    <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`} rel="noopener noreferrer" target="_blank" data-testid="modal.member-power-limit.support-link"> Support Team </a>
                    {`to purchase more subscriptions.`}
                </p>
                <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={close} data-testid="modal.member-power-limit.ok-btn">OK</button>
            </div>
        </Modal>
    );
};
